import { render, staticRenderFns } from "./AccountViewer.vue?vue&type=template&id=132c5036&scoped=true&"
import script from "./AccountViewer.vue?vue&type=script&lang=ts&"
export * from "./AccountViewer.vue?vue&type=script&lang=ts&"
import style0 from "./AccountViewer.vue?vue&type=style&index=0&id=132c5036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132c5036",
  null
  
)

export default component.exports